import classNames from 'classnames';
import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { actions } from '../../../Slice/PersonProfileSlice';
import { Executive } from '../../../Types/PersonTypes';
import { SalesAlignmentItem, SalesAlignmentRow } from '../../../Types/GlobalTypes';
import { selectAlignmentRowStaff, selectSalesAlignmentPersons } from '../../../Selector/PersonProfileSelector';
import AlignmentPopoverList from './AlignmentPopoverList';
const Wrapper = styled.div`
 &.add-new-row-popover {
  border-radius: 14px;
  background: #FFF;
  height: 270px;
  width: 230px;
  &.noStaff {
    .empty-list {
      width: 100%;
      height: 80%;
    }
  }
  }
`;
type Props = {
  currentUser: Executive | null;
  userIds: SalesAlignmentRow[];
  rowId: number;
  personsList: Executive;
  closePopover: () => void;
};
const defaultProps = {
  currentUser: [],
  userIds: [],
  rowId: 0,
  personsList: [],
}

const AddAlignmentRowPopover = function AddAlignmentRowPopover(props: Props) {
  const { currentUser, rowId, personsList, closePopover } = props
  const [query, setQuery] = useState('');
  const dispatch = useDispatch();
  const alignmentRowStaff = useSelector(selectAlignmentRowStaff(rowId));
  const salesAlignmentPersons = useSelector(selectSalesAlignmentPersons);
  const staffPage = alignmentRowStaff.page;
  const staffLoading = alignmentRowStaff.loading;
  const totalStaff = alignmentRowStaff.count;
  const staffData = alignmentRowStaff.staff;
  
  const disabledIds = useMemo(() => {
    const rows = salesAlignmentPersons?.rows ?? [];
    const currentRow = rows.find((row) => row.rowId === rowId);

    const leftBaseColumnIds = rows
      .filter((row) => row.rowId !== rowId)
      .map((row) => row.currentUser?.personId)
      .filter((id): id is number => typeof id === 'number' && id > 0);

    const currentRowPersonIds = (currentRow?.personsList ?? [])
      .map((item) => item?.person?.personId)
      .filter((id): id is number => typeof id === 'number' && id > 0);

    return [...new Set([...leftBaseColumnIds, ...currentRowPersonIds])];
  }, [rowId, salesAlignmentPersons?.rows]);

  const getAlignmentRow = (selectedAffinityPersonId: number) => {
    const currentRow = salesAlignmentPersons?.rows?.find((row) => row.rowId === rowId);
    const profilePersonId = personsList?.personId ?? currentRow?.personsList?.[0]?.person?.personId;

    const affinityWasSelectedBefore = Boolean(currentRow?.currentUser?.personId);
    const affinityChanged = affinityWasSelectedBefore && currentRow?.currentUser?.personId !== selectedAffinityPersonId;

    const rowHasExtraPeople = (currentRow?.personsList?.length ?? 0) > 1;
    const shouldSendPersonIds = affinityChanged && rowHasExtraPeople;

    const extraPersonIds = (currentRow?.personsList ?? [])
      .slice(1)
      .map((item: SalesAlignmentItem) => item?.person?.personId)
      .filter((id): id is number => typeof id === 'number' && id > 0 && id !== profilePersonId);

    const personIds = shouldSendPersonIds ? extraPersonIds.join(',') : '';

    dispatch(actions.getMultipleSalesAlignment({
      personId: profilePersonId,
      ...(personIds ? { personIds } : {}),
      affinityPerson: selectedAffinityPersonId,
      rowId: rowId,
    }))
    closePopover();
  }
  const onSearching = (q: string) => {
    setQuery(q);
    if (currentUser?.companyId !== 0) {
      dispatch(actions.addAlignmentRow({
        query: q,
        page: 1,
        companyId: currentUser?.companyId ?? 0,
        screenName: 'multiSales',
        rowId,
      }));
    }
  };

  const fetchMoreStaff = () => {
    if (currentUser?.companyId !== 0) {
      dispatch(actions.addAlignmentRow({
        query,
        page: staffPage,
        companyId: currentUser?.companyId ?? 0,
        screenName: 'multiSales',
        rowId,
      }));
    }
  };


  return (
    <Wrapper
      className={classNames("add-new-row-popover")}
    >
      <AlignmentPopoverList
        staff={staffData}
        totalStaff={totalStaff}
        loading={staffLoading}
        disabledIds={disabledIds}
        onSelect={getAlignmentRow}
        onFetchMore={fetchMoreStaff}
        onSearching={onSearching}
        query={query}
        scrollContainerId={`scrollPeople-multisales-addrow-${rowId}`}
      />
    </Wrapper>
  );
};
AddAlignmentRowPopover.defaultProps = defaultProps
export default AddAlignmentRowPopover;
